import { useEffect, useState } from "react";
import { ArrowUpRight } from "lucide-react";
import { fetchPosts } from "../../lib/api";
import { Reveal, SectionHead } from "./Reveal";
import { Dialog, DialogContent, DialogTitle, DialogDescription } from "../ui/dialog";

const fmt = (d) => {
  const t = new Date(d);
  return isNaN(t) ? "" : t.toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" });
};

const Row = ({ post, i, onOpen }) => (
  <Reveal delay={i * 0.05}>
    <button onClick={() => onOpen(post)} data-testid={`update-card-read-more-${i}`}
      className="group grid w-full grid-cols-1 md:grid-cols-12 gap-3 md:gap-6 border-t border-cyan-400/12 py-8 text-left hover:bg-[#0F1829]/60 transition-colors md:px-4">
      <span className="md:col-span-2 font-mono text-xs uppercase tracking-[0.2em] text-slate-400">{fmt(post.created_at)}</span>
      <span className="md:col-span-2"><span className="rounded-full border border-cyan-400/30 px-3 py-1 font-mono text-[11px] uppercase tracking-[0.2em] text-[#00E5FF]">{post.tag || "Update"}</span></span>
      <span className="md:col-span-7">
        <span className="block font-display text-2xl sm:text-3xl font-extrabold uppercase text-white group-hover:text-[#00E5FF] transition-colors">{post.title}</span>
        <span className="mt-2 block text-sm sm:text-base text-slate-300 line-clamp-2">{post.content}</span>
      </span>
      <ArrowUpRight className="hidden md:block md:col-span-1 h-7 w-7 justify-self-end text-slate-400 group-hover:text-[#00E5FF] group-hover:-translate-y-1 group-hover:translate-x-1 transition-[transform,color]" />
    </button>
  </Reveal>
);

export const Updates = () => {
  const [posts, setPosts] = useState([]);
  const [open, setOpen] = useState(null);
  useEffect(() => {
    fetchPosts("update").then(setPosts);
  }, []);
  return (
    <section id="updates" className="mx-auto max-w-7xl px-5 sm:px-8 py-24 sm:py-36">
      <SectionHead over="// 04 — Dev log" title={<>Updates from<br />the dock.</>} />
      <div className="border-b border-cyan-400/12">
        {posts.map((p, i) => <Row key={p.id} post={p} i={i} onOpen={setOpen} />)}
        {posts.length === 0 && <p className="border-t border-cyan-400/12 py-10 font-mono text-sm text-slate-400" data-testid="updates-empty">No updates yet — first transmission incoming.</p>}
      </div>
      <Dialog open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <DialogContent data-testid="update-modal" className="max-w-2xl border-cyan-400/20 bg-[#0A101D] text-white max-h-[85vh] overflow-y-auto">
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-[#00E5FF]">{open?.tag || "Update"} · {fmt(open?.created_at)}</p>
          <DialogTitle className="font-display text-3xl font-extrabold uppercase">{open?.title}</DialogTitle>
          {open?.image_url && <img src={open.image_url} alt="" className="aspect-video w-full rounded-xl object-cover" />}
          <DialogDescription className="whitespace-pre-line text-base text-slate-300">{open?.content}</DialogDescription>
        </DialogContent>
      </Dialog>
    </section>
  );
};
